import { Bt as e, Dt as t, Ft as n, Ht as r, It as i, Lt as a, Nt as o, Ot as s, Pt as c, Rt as l, Vt as u, g as d, gt as f, h as p, kt as m, on as h, pn as g, r as ee, sn as te, zt as ne } from "./blocks-CpMAs3pB.js";
import { n as _, t as v } from "./BlockNoteExtension-BXhE27K9.js";
import { DOMSerializer as y, Fragment as b, Slice as re } from "prosemirror-model";
import { dropPoint as ie } from "prosemirror-transform";
import { combineTransactionSteps as ae, findChildrenInRange as x, posToDOMRect as oe } from "@tiptap/core";
import { NodeSelection as se, Plugin as S, PluginKey as C, Selection as w, TextSelection as ce } from "prosemirror-state";
import { uuidv4 as le } from "lib0/random";
import { DOMParser as ue, Slice as de } from "@tiptap/pm/model";
import { CellSelection as fe, addColumnAfter as pe, addColumnBefore as me, addRowAfter as he, addRowBefore as ge, deleteColumn as _e, deleteRow as ve, mergeCells as ye, splitCell as be } from "prosemirror-tables";
import { Plugin as T, PluginKey as E, TextSelection as xe } from "@tiptap/pm/state";
import { Decoration as D, DecorationSet as O } from "prosemirror-view";
import { defaultSelectionBuilder as Se, redoCommand as Ce, undoCommand as we, yCursorPlugin as Te, ySyncPlugin as Ee, yUndoPlugin as De, yUndoPluginKey as k } from "y-prosemirror";
import Oe from "fast-deep-equal";
import * as A from "yjs";
import { history as ke, redo as Ae, undo as je } from "@tiptap/pm/history";
import Me from "rehype-parse";
import Ne from "rehype-remark";
import Pe from "remark-gfm";
import Fe from "remark-stringify";
import { unified as Ie } from "unified";
import { fromDom as Le } from "hast-util-from-dom";
import { visit as Re } from "unist-util-visit";
//#region src/api/exporters/html/util/serializeBlocksExternalHTML.ts
function j(e) {
	let t = Array.from(e.classList).filter((e) => !e.startsWith("bn-")) || [];
	t.length > 0 ? e.className = t.join(" ") : e.removeAttribute("class");
}
function M(e, t, n, r, i = "paragraph") {
	if (!t) throw Error("blockContent is required");
	let a = m(t, e.pmSchema, i, void 0, { inlineBlockType: void 0 }), o = (r?.document ?? document).createDocumentFragment();
	for (let t of a) if (t.type.name !== "text" && e.schema.inlineContentSchema[t.type.name]) {
		let i = e.schema.inlineContentSpecs[t.type.name].implementation;
		if (i) {
			let a = te(t, e.schema.inlineContentSchema, e.schema.styleSchema), s = i.toExternalHTML ? i.toExternalHTML(a, e) : i.render.call({
				renderType: "dom",
				props: void 0
			}, a, () => {}, e);
			if (s) {
				if (o.appendChild(s.dom), s.contentDOM) {
					let e = n.serializeFragment(t.content, r);
					s.contentDOM.dataset.editable = "", s.contentDOM.appendChild(e);
				}
				continue;
			}
		}
	} else if (t.type.name === "text") {
		let n = document.createTextNode(t.textContent);
		for (let r of t.marks.toReversed()) if (r.type.name in e.schema.styleSpecs) {
			let t = (e.schema.styleSpecs[r.type.name].implementation.toExternalHTML ?? e.schema.styleSpecs[r.type.name].implementation.render)(r.attrs.stringValue, e);
			t.contentDOM.appendChild(n), n = t.dom;
		} else {
			let e = r.type.spec.toDOM(r, !0), t = y.renderSpec(document, e);
			t.contentDOM.appendChild(n), n = t.dom;
		}
		o.appendChild(n);
	} else {
		let e = n.serializeFragment(b.from([t]), r);
		o.appendChild(e);
	}
	return o.childNodes.length === 1 && o.firstChild?.nodeType === 1 && j(o.firstChild), o;
}
function ze(e, t, n, r, i, a, o, s) {
	let c = s?.document ?? document, l = t.pmSchema.nodes.blockContainer, u = n.props || {};
	for (let [e, r] of Object.entries(t.schema.blockSchema[n.type].propSchema)) !(e in u) && r.default !== void 0 && (u[e] = r.default);
	let d = l.spec?.toDOM?.(l.create({
		id: n.id,
		...u
	})), f = Array.from(d.dom.attributes), p = t.blockImplementations[n.type].implementation, m = p.toExternalHTML?.call({}, {
		...n,
		props: u
	}, t, { nestingLevel: o }) || p.render.call({}, {
		...n,
		props: u
	}, t), h = c.createDocumentFragment();
	if (m.dom.classList.contains("bn-block-content")) {
		let e = [...f, ...Array.from(m.dom.attributes)].filter((e) => e.name.startsWith("data") && e.name !== "data-content-type" && e.name !== "data-file-block" && e.name !== "data-node-view-wrapper" && e.name !== "data-node-type" && e.name !== "data-id" && e.name !== "data-editable");
		for (let t of e) m.dom.firstChild.setAttribute(t.name, t.value);
		j(m.dom.firstChild), o > 0 && m.dom.firstChild.setAttribute("data-nesting-level", o.toString()), h.append(...Array.from(m.dom.childNodes));
	} else h.append(m.dom), o > 0 && m.dom.setAttribute("data-nesting-level", o.toString());
	if (m.contentDOM && n.content) {
		let e = M(t, n.content, r, s, n.type);
		m.contentDOM.appendChild(e);
	}
	let g;
	if (i.has(n.type) ? g = "OL" : a.has(n.type) && (g = "UL"), g) {
		if (e.lastChild?.nodeName !== g) {
			let t = c.createElement(g);
			g === "OL" && "start" in u && u.start && u?.start !== 1 && t.setAttribute("start", u.start + ""), e.append(t);
		}
		e.lastChild.appendChild(h);
	} else e.append(h);
	if (n.children && n.children.length > 0) {
		let l = c.createDocumentFragment();
		if (N(l, t, n.children, r, i, a, o + 1, s), e.lastChild?.nodeName === "UL" || e.lastChild?.nodeName === "OL") for (; l.firstChild?.nodeName === "UL" || l.firstChild?.nodeName === "OL";) e.lastChild.lastChild.appendChild(l.firstChild);
		"childrenDOM" in m && m.childrenDOM ? m.childrenDOM.append(l) : t.pmSchema.nodes[n.type].isInGroup("blockContent") ? e.append(l) : m.contentDOM?.append(l);
	}
}
var N = (e, t, n, r, i, a, o = 0, s) => {
	for (let c of n) ze(e, t, c, r, i, a, o, s);
}, Be = (e, t, n, r, i, a) => {
	let o = (a?.document ?? document).createDocumentFragment();
	return N(o, e, t, n, r, i, 0, a), o;
}, P = (e, t) => {
	let n = y.fromSchema(e);
	return {
		exportBlocks: (e, r) => {
			let i = Be(t, e, n, new Set(["numberedListItem"]), new Set([
				"bulletListItem",
				"checkListItem",
				"toggleListItem"
			]), r), a = document.createElement("div");
			return a.append(i), a.innerHTML;
		},
		exportInlineContent: (e, r, i) => {
			let a = M(t, e, n, r, i), o = document.createElement("div");
			return o.append(a.cloneNode(!0)), o.innerHTML;
		}
	};
};
//#endregion
//#region src/api/getBlocksChangedByTransaction.ts
function Ve(e, t) {
	if (t === 0) return;
	let n = e.resolve(t);
	for (let e = n.depth; e > 0; e--) {
		let t = n.node(e);
		if (s(t)) return t.attrs.id;
	}
}
function He(e) {
	return e.getMeta("paste") ? { type: "paste" } : e.getMeta("uiEvent") === "drop" ? { type: "drop" } : e.getMeta("history$") ? { type: e.getMeta("history$").redo ? "redo" : "undo" } : e.getMeta("y-sync$") ? e.getMeta("y-sync$").isUndoRedoOperation ? { type: "undo-redo" } : { type: "yjs-remote" } : { type: "local" };
}
function F(e) {
	let t = {}, n = {}, r = g(e);
	return e.descendants((i, a) => {
		if (!s(i)) return !0;
		let o = Ve(e, a), c = o ?? "__root__";
		n[c] || (n[c] = []);
		let l = h(i, r);
		return t[i.attrs.id] = {
			block: l,
			parentId: o
		}, n[c].push(i.attrs.id), !0;
	}), {
		byId: t,
		childrenByParent: n
	};
}
function Ue(e, t) {
	let n = /* @__PURE__ */ new Set();
	if (!e || !t) return n;
	let r = new Set(e), i = t.filter((e) => r.has(e)), a = e.filter((e) => i.includes(e));
	if (a.length <= 1 || i.length <= 1) return n;
	let o = {};
	for (let e = 0; e < a.length; e++) o[a[e]] = e;
	let s = i.map((e) => o[e]), c = s.length, l = [], u = [], d = Array(c).fill(-1), f = (e, t) => {
		let n = 0, r = e.length;
		for (; n < r;) {
			let i = n + r >>> 1;
			e[i] < t ? n = i + 1 : r = i;
		}
		return n;
	};
	for (let e = 0; e < c; e++) {
		let t = s[e], n = f(l, t);
		n > 0 && (d[e] = u[n - 1]), n === l.length ? (l.push(t), u.push(e)) : (l[n] = t, u[n] = e);
	}
	let p = /* @__PURE__ */ new Set(), m = u[u.length - 1] ?? -1;
	for (; m !== -1;) p.add(m), m = d[m];
	for (let e = 0; e < i.length; e++) p.has(e) || n.add(i[e]);
	return n;
}
function I(e, t = []) {
	let n = He(e), r = ae(e.before, [e, ...t]), i = F(r.before), a = F(r.doc), o = [], s = /* @__PURE__ */ new Set();
	Object.keys(a.byId).filter((e) => !(e in i.byId)).forEach((e) => {
		o.push({
			type: "insert",
			block: a.byId[e].block,
			source: n,
			prevBlock: void 0
		}), s.add(e);
	}), Object.keys(i.byId).filter((e) => !(e in a.byId)).forEach((e) => {
		o.push({
			type: "delete",
			block: i.byId[e].block,
			source: n,
			prevBlock: void 0
		}), s.add(e);
	}), Object.keys(a.byId).filter((e) => e in i.byId).forEach((e) => {
		let t = i.byId[e], r = a.byId[e];
		t.parentId === r.parentId ? Oe({
			...t.block,
			children: void 0
		}, {
			...r.block,
			children: void 0
		}) || (o.push({
			type: "update",
			block: r.block,
			prevBlock: t.block,
			source: n
		}), s.add(e)) : (o.push({
			type: "move",
			block: r.block,
			prevBlock: t.block,
			source: n,
			prevParent: t.parentId ? i.byId[t.parentId]?.block : void 0,
			currentParent: r.parentId ? a.byId[r.parentId]?.block : void 0
		}), s.add(e));
	});
	let c = i.childrenByParent, l = a.childrenByParent, u = new Set([...Object.keys(c), ...Object.keys(l)]), d = /* @__PURE__ */ new Set();
	return u.forEach((e) => {
		let t = Ue(c[e], l[e]);
		t.size !== 0 && t.forEach((t) => {
			let r = i.byId[t], c = a.byId[t];
			!r || !c || r.parentId === c.parentId && (s.has(t) || (r.parentId ?? "__root__") === e && (d.has(t) || (d.add(t), o.push({
				type: "move",
				block: c.block,
				prevBlock: r.block,
				source: n,
				prevParent: r.parentId ? i.byId[r.parentId]?.block : void 0,
				currentParent: c.parentId ? a.byId[c.parentId]?.block : void 0
			}), s.add(t))));
		});
	}), o;
}
//#endregion
//#region src/extensions/BlockChange/BlockChange.ts
var We = v(() => {
	let e = [];
	return {
		key: "blockChange",
		prosemirrorPlugins: [new S({
			key: new C("blockChange"),
			filterTransaction: (t) => {
				let n;
				return e.reduce((e, r) => e === !1 ? e : r({
					getChanges() {
						return n || (n = I(t), n);
					},
					tr: t
				}) !== !1, !0);
			}
		})],
		subscribe(t) {
			return e.push(t), () => {
				e.splice(e.indexOf(t), 1);
			};
		}
	};
});
//#endregion
//#region src/extensions/Collaboration/YCursorPlugin.ts
function L(e) {
	let t = e.charAt(0) === "#" ? e.substring(1, 7) : e, n = parseInt(t.substring(0, 2), 16), r = parseInt(t.substring(2, 4), 16), i = parseInt(t.substring(4, 6), 16), a = [
		n / 255,
		r / 255,
		i / 255
	].map((e) => e <= .03928 ? e / 12.92 : ((e + .055) / 1.055) ** 2.4);
	return .2126 * a[0] + .7152 * a[1] + .0722 * a[2] <= .179;
}
function Ge(e) {
	let t = document.createElement("span");
	t.classList.add("bn-collaboration-cursor__base");
	let n = document.createElement("span");
	n.setAttribute("contentedEditable", "false"), n.classList.add("bn-collaboration-cursor__caret"), n.setAttribute("style", `background-color: ${e.color}; color: ${L(e.color) ? "white" : "black"}`);
	let r = document.createElement("span");
	return r.classList.add("bn-collaboration-cursor__label"), r.setAttribute("style", `background-color: ${e.color}; color: ${L(e.color) ? "white" : "black"}`), r.insertBefore(document.createTextNode(e.name), null), n.insertBefore(r, null), t.insertBefore(document.createTextNode("⁠"), null), t.insertBefore(n, null), t.insertBefore(document.createTextNode("⁠"), null), t;
}
var R = v(({ options: e }) => {
	let t = /* @__PURE__ */ new Map(), n = e.provider && "awareness" in e.provider && typeof e.provider.awareness == "object" ? e.provider.awareness : void 0;
	return n && ("setLocalStateField" in n && typeof n.setLocalStateField == "function" && n.setLocalStateField("user", e.user), "on" in n && typeof n.on == "function" && e.showCursorLabels !== "always" && n.on("change", ({ updated: e }) => {
		for (let n of e) {
			let e = t.get(n);
			e && (setTimeout(() => {
				e.element.setAttribute("data-active", "");
			}, 10), e.hideTimeout && clearTimeout(e.hideTimeout), t.set(n, {
				element: e.element,
				hideTimeout: setTimeout(() => {
					e.element.removeAttribute("data-active");
				}, 2e3)
			}));
		}
	})), {
		key: "yCursor",
		prosemirrorPlugins: [n ? Te(n, {
			selectionBuilder: Se,
			cursorBuilder(n, r) {
				let i = t.get(r);
				if (!i) {
					let a = (e.renderCursor ?? Ge)(n);
					e.showCursorLabels !== "always" && (a.addEventListener("mouseenter", () => {
						let e = t.get(r);
						e.element.setAttribute("data-active", ""), e.hideTimeout && (clearTimeout(e.hideTimeout), t.set(r, {
							element: e.element,
							hideTimeout: void 0
						}));
					}), a.addEventListener("mouseleave", () => {
						let e = t.get(r);
						t.set(r, {
							element: e.element,
							hideTimeout: setTimeout(() => {
								e.element.removeAttribute("data-active");
							}, 2e3)
						});
					})), i = {
						element: a,
						hideTimeout: void 0
					}, t.set(r, i);
				}
				return i.element;
			}
		}) : void 0].filter(Boolean),
		dependsOn: ["ySync"],
		updateUser(e) {
			n?.setLocalStateField("user", e);
		}
	};
}), z = v(({ options: e }) => ({
	key: "ySync",
	prosemirrorPlugins: [Ee(e.fragment)],
	runsBefore: ["default"]
})), B = v(() => ({
	key: "yUndo",
	prosemirrorPlugins: [De()],
	dependsOn: ["yCursor", "ySync"],
	undoCommand: we,
	redoCommand: Ce
}));
//#endregion
//#region src/extensions/Collaboration/ForkYDoc.ts
function Ke(e, t) {
	let n = e.doc;
	if (e._item === null) {
		let r = Array.from(n.share.keys()).find((t) => n.share.get(t) === e);
		if (r == null) throw Error("type does not exist in other ydoc");
		return t.get(r, e.constructor);
	} else {
		let n = e._item, r = t.store.clients.get(n.id.client) ?? [];
		return r[A.findIndexSS(r, n.id.clock)].content.type;
	}
}
var qe = v(({ editor: e, options: t }) => {
	let n, r = _({ isForked: !1 });
	return {
		key: "yForkDoc",
		store: r,
		fork() {
			if (n) return;
			let i = t.fragment;
			if (!i) throw Error("No fragment to fork from");
			let a = new A.Doc();
			A.applyUpdate(a, A.encodeStateAsUpdate(i.doc));
			let o = Ke(i, a);
			n = {
				undoStack: k.getState(e.prosemirrorState).undoManager.undoStack,
				originalFragment: i,
				forkedFragment: o
			}, e.unregisterExtension([
				B,
				R,
				z
			]);
			let s = {
				...t,
				fragment: o
			};
			e.registerExtension([z(s), B()]), r.setState({ isForked: !0 });
		},
		merge({ keepChanges: i }) {
			if (!n) return;
			e.unregisterExtension([
				"ySync",
				"yCursor",
				"yUndo"
			]);
			let { originalFragment: a, forkedFragment: o, undoStack: s } = n;
			if (e.registerExtension([
				z(t),
				R(t),
				B()
			]), k.getState(e.prosemirrorState).undoManager.undoStack = s, i) {
				let t = A.encodeStateAsUpdate(o.doc, A.encodeStateVector(a.doc));
				A.applyUpdate(a.doc, t, e);
			}
			n = void 0, r.setState({ isForked: !1 });
		}
	};
}), V = (e, t) => {
	t(e), e.forEach((e) => {
		e instanceof A.XmlElement && V(e, t);
	});
}, Je = [(e, t) => {
	let n = /* @__PURE__ */ new Map();
	return e.forEach((e) => {
		e instanceof A.XmlElement && V(e, (e) => {
			if (e.nodeName === "blockContainer" && e.hasAttribute("id")) {
				let t = e.getAttribute("textColor"), r = e.getAttribute("backgroundColor"), i = {
					textColor: t === f.textColor.default ? void 0 : t,
					backgroundColor: r === f.backgroundColor.default ? void 0 : r
				};
				(i.textColor || i.backgroundColor) && n.set(e.getAttribute("id"), i);
			}
		});
	}), n.size === 0 ? !1 : (t.doc.descendants((e, r) => {
		if (e.type.name === "blockContainer" && n.has(e.attrs.id)) {
			let i = t.doc.nodeAt(r + 1);
			if (!i) throw Error("No element found");
			t.setNodeMarkup(r + 1, void 0, {
				...i.attrs,
				...n.get(e.attrs.id)
			});
		}
	}), !0);
}], Ye = v(({ options: e }) => {
	let t = !1;
	return {
		key: "schemaMigration",
		prosemirrorPlugins: [new T({
			key: new E("schemaMigration"),
			appendTransaction: (n, r, i) => {
				if (t || !n.some((e) => e.getMeta("y-sync$")) || n.every((e) => !e.docChanged) || !e.fragment.firstChild) return;
				let a = i.tr;
				for (let t of Je) t(e.fragment, a);
				if (t = !0, a.docChanged) return a;
			}
		})]
	};
});
//#endregion
//#region src/extensions/DropCursor/utils.ts
function H(e, t) {
	return !e || !t ? !1 : !!e.closest(`.${t}`);
}
function Xe(e, t, n, r, i) {
	let a = e.state.doc.resolve(t.pos);
	if (a.parent.inlineContent || t.orientation === "inline") return null;
	let o = a.nodeBefore, s = a.nodeAfter;
	if (!o && !s) return null;
	let c = t.orientation === "block-vertical-left" || t.orientation === "block-vertical-right", l = c ? t.pos : t.pos - (o ? o.nodeSize : 0), u = e.nodeDOM(l);
	if (!u) return null;
	let d = u.getBoundingClientRect();
	if (c) {
		let e = n / 2 * r, i = t.orientation === "block-vertical-left" ? d.left : d.right;
		return {
			left: i - e,
			right: i + e,
			top: d.top,
			bottom: d.bottom
		};
	}
	let f = o ? d.bottom : d.top;
	o && s && (f = (f + e.nodeDOM(t.pos).getBoundingClientRect().top) / 2);
	let p = n / 2 * i;
	return {
		left: d.left,
		right: d.right,
		top: f - p,
		bottom: f + p
	};
}
function Ze(e, t, n, r) {
	let i = e.coordsAtPos(t.pos), a = n / 2 * r;
	return {
		left: i.left - a,
		right: i.left + a,
		top: i.top,
		bottom: i.bottom
	};
}
function Qe(e, t) {
	e.classList.toggle("prosemirror-dropcursor-inline", t === "inline"), e.classList.toggle("prosemirror-dropcursor-block-horizontal", t === "block-horizontal"), e.classList.toggle("prosemirror-dropcursor-block-vertical-left", t === "block-vertical-left"), e.classList.toggle("prosemirror-dropcursor-block-vertical-right", t === "block-vertical-right"), e.classList.toggle("prosemirror-dropcursor-block", t === "block-horizontal"), e.classList.toggle("prosemirror-dropcursor-vertical", t === "block-vertical-left" || t === "block-vertical-right");
}
function $e(e) {
	if (!e || e === document.body && getComputedStyle(e).position === "static") return {
		parentLeft: -window.pageXOffset,
		parentTop: -window.pageYOffset
	};
	let t = e.getBoundingClientRect(), n = t.width / e.offsetWidth, r = t.height / e.offsetHeight;
	return {
		parentLeft: t.left - e.scrollLeft * n,
		parentTop: t.top - e.scrollTop * r
	};
}
//#endregion
//#region src/extensions/DropCursor/DropCursor.ts
var et = "bn-drag-exclude", tt = v(({ editor: e, options: t }) => {
	let n = null, r = null, i = -1, a = null, o = {
		width: t.dropCursor?.width ?? 5,
		color: t.dropCursor?.color ?? "#ddeeff",
		exclude: t.dropCursor?.exclude ?? "bn-drag-exclude",
		hooks: t.dropCursor?.hooks
	}, s = (e) => {
		e?.pos === n?.pos && e?.orientation === n?.orientation || (n = e, e == null ? (r && r.parentNode && r.parentNode.removeChild(r), r = null) : c());
	}, c = () => {
		if (!n) return;
		let t = e.prosemirrorView, i = t.dom, a = i.getBoundingClientRect(), s = a.width / i.offsetWidth, c = a.height / i.offsetHeight, l = Xe(t, n, o.width, s, c) ?? Ze(t, n, o.width, s), u = t.dom.offsetParent;
		r || (r = u.appendChild(document.createElement("div")), r.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", o.color && (r.style.backgroundColor = o.color)), Qe(r, n.orientation);
		let { parentLeft: d, parentTop: f } = $e(u);
		r.style.left = (l.left - d) / s + "px", r.style.top = (l.top - f) / c + "px", r.style.width = (l.right - l.left) / s + "px", r.style.height = (l.bottom - l.top) / c + "px";
	}, l = (e) => {
		clearTimeout(i), i = window.setTimeout(() => s(null), e);
	}, u = (e) => {
		let t = e;
		a = t.target instanceof Element ? t.target : null;
	}, d = (t) => {
		let n = t;
		if (a && H(a, o.exclude) || n.target instanceof Element && H(n.target, o.exclude)) return;
		let r = e.prosemirrorView;
		if (!r.editable) return;
		let i = r.posAtCoords({
			left: n.clientX,
			top: n.clientY
		}), c = i && i.inside >= 0 && r.state.doc.nodeAt(i.inside), u = c && c.type.spec.disableDropCursor, d = typeof u == "function" ? u(r, i, n) : u;
		if (i && !d) {
			let t = i.pos;
			if (r.dragging && r.dragging.slice) {
				let e = ie(r.state.doc, t, r.dragging.slice);
				e != null && (t = e);
			}
			let a = !r.state.doc.resolve(t).parent.inlineContent, c = {
				pos: t,
				orientation: a ? "block-horizontal" : "inline"
			}, u = c;
			if (o.hooks?.computeDropPosition) {
				let t = o.hooks.computeDropPosition({
					editor: e,
					event: n,
					view: r,
					defaultPosition: c
				});
				if (t === null) {
					s(null);
					return;
				}
				u = t;
			}
			s(u), l(5e3);
		}
	}, f = (t) => {
		let n = t;
		(!(n.relatedTarget instanceof Node) || !e.prosemirrorView.dom.contains(n.relatedTarget)) && s(null);
	}, p = () => {
		l(20);
	}, m = () => {
		l(20), a = null;
	};
	return {
		key: "dropCursor",
		mount({ signal: e, dom: t, root: n }) {
			n.addEventListener("dragstart", u, {
				capture: !0,
				signal: e
			}), t.addEventListener("dragover", d, { signal: e }), t.addEventListener("dragleave", f, { signal: e }), t.addEventListener("drop", p, { signal: e }), t.addEventListener("dragend", m, { signal: e }), e.addEventListener("abort", () => {
				clearTimeout(i), s(null);
			});
		}
	};
}), nt = v(({ editor: e }) => {
	let t = _(!1), n = () => e.transact((e) => {
		if (e.selection.empty || e.selection instanceof ce && e.doc.textBetween(e.selection.from, e.selection.to).length === 0) return !1;
		let t = !1;
		return e.selection.content().content.descendants((e) => (e.type.spec.code && (t = !0), !t)), !t;
	});
	return {
		key: "formattingToolbar",
		store: t,
		mount({ dom: r, signal: i }) {
			let a = !1, o = !1, s = e.onChange(() => {
				a || o || t.setState(n());
			}), c = e.onSelectionChange(() => {
				a || o || t.setState(n());
			});
			r.addEventListener("pointerdown", () => {
				a = !0, t.setState(!1);
			}, { signal: i }), e.prosemirrorView.root.addEventListener("pointerup", () => {
				a = !1, e.isFocused() && t.setState(n());
			}, {
				signal: i,
				capture: !0
			}), r.addEventListener("pointercancel", () => {
				a = !0;
			}, {
				signal: i,
				capture: !0
			}), e.prosemirrorView.root.addEventListener("dragstart", () => {
				o = !0, t.setState(!1);
			}, { signal: i }), e.prosemirrorView.root.addEventListener("dragend", () => {
				o = !1;
			}, { signal: i }), i.addEventListener("abort", () => {
				s(), c();
			});
		}
	};
}), rt = v(() => ({
	key: "history",
	prosemirrorPlugins: [ke()],
	undoCommand: je,
	redoCommand: Ae
})), it = v(({ editor: e }) => {
	function t(t) {
		let n = e.prosemirrorView.nodeDOM(t);
		for (; n && n.parentElement;) {
			if (n.nodeName === "A") return n;
			n = n.parentElement;
		}
		return null;
	}
	function n(t) {
		let n = e.getLinkMarkAtPos(t);
		if (n) return {
			range: {
				from: n.from,
				to: n.to
			},
			mark: { attrs: { href: n.href } },
			get text() {
				return n.text;
			},
			get position() {
				return oe(e.prosemirrorView, n.from, n.to).toJSON();
			}
		};
	}
	function r() {
		return e.transact((e) => {
			if (e.selection.empty) return n(e.selection.anchor);
		});
	}
	return {
		key: "linkToolbar",
		getLinkAtSelection: r,
		getLinkElementAtPos: t,
		getMarkAtPos(e, t) {
			return n(e);
		},
		getLinkAtElement(t) {
			return e.transact(() => n(e.prosemirrorView.posAtDOM(t, 0) + 1));
		},
		editLink(t, n, r = e.transact((e) => e.selection.anchor)) {
			e.editLink(t, n, r);
		},
		deleteLink(t = e.transact((e) => e.selection.anchor)) {
			e.deleteLink(t);
		}
	};
}), at = [
	"http",
	"https",
	"ftp",
	"ftps",
	"mailto",
	"tel",
	"callto",
	"sms",
	"cid",
	"xmpp"
], ot = "https", st = new C("node-selection-keyboard"), ct = v(() => ({
	key: "nodeSelectionKeyboard",
	prosemirrorPlugins: [new S({
		key: st,
		props: { handleKeyDown: (e, t) => {
			if ("node" in e.state.selection) {
				if (t.ctrlKey || t.metaKey) return !1;
				if (t.key.length === 1) return t.preventDefault(), !0;
				if (t.key === "Enter" && !t.isComposing && !t.shiftKey && !t.altKey && !t.ctrlKey && !t.metaKey) {
					let t = e.state.tr;
					return e.dispatch(t.insert(e.state.tr.selection.$to.after(), e.state.schema.nodes.paragraph.createChecked()).setSelection(new ce(t.doc.resolve(e.state.tr.selection.$to.after() + 1)))), !0;
				}
			}
			return !1;
		} }
	})]
})), lt = new C("blocknote-placeholder"), ut = v(({ editor: e, options: t }) => {
	let n = t.placeholders;
	return {
		key: "placeholder",
		prosemirrorPlugins: [new S({
			key: lt,
			view: (t) => {
				let r = `placeholder-selector-${le()}`;
				t.dom.classList.add(r);
				let i = document.createElement("style"), a = e._tiptapEditor.options.injectNonce;
				a && i.setAttribute("nonce", a), t.root instanceof window.ShadowRoot ? t.root.append(i) : t.root.head.appendChild(i);
				let o = i.sheet, s = (e = "") => `.${r} .bn-block-content${e}:has(.ProseMirror-trailingBreak:only-child):after`;
				try {
					let { default: e, emptyDocument: t, ...r } = n || {};
					for (let [e, t] of Object.entries(r)) {
						let n = `[data-content-type="${e}"]`;
						o.insertRule(`${s(n)} { content: ${JSON.stringify(t)}; }`);
					}
					o.insertRule(`${s("[data-is-only-empty-block]")} { content: ${JSON.stringify(t)}; }`), o.insertRule(`${s("[data-is-empty-and-focused]")} { content: ${JSON.stringify(e)}; }`);
				} catch (e) {
					console.warn("Failed to insert placeholder CSS rule - this is likely due to the browser not supporting certain CSS pseudo-element selectors (:has, :only-child:, or :before)", e);
				}
				return { destroy: () => {
					t.root instanceof window.ShadowRoot ? t.root.removeChild(i) : t.root.head.removeChild(i);
				} };
			},
			props: { decorations: (t) => {
				let { doc: n, selection: r } = t;
				if (!e.isEditable || !r.empty || r.$from.parent.type.spec.code) return;
				let i = [];
				t.doc.content.size === 6 && i.push(D.node(2, 4, { "data-is-only-empty-block": "true" }));
				let a = r.$anchor, o = a.parent;
				if (o.content.size === 0) {
					let e = a.before();
					i.push(D.node(e, e + o.nodeSize, { "data-is-empty-and-focused": "true" }));
				}
				return O.create(n, i);
			} }
		})]
	};
}), U = new C("previous-blocks"), dt = {
	index: "index",
	level: "level",
	type: "type",
	depth: "depth",
	"depth-change": "depth-change"
}, ft = v(() => {
	let e;
	return {
		key: "previousBlockType",
		prosemirrorPlugins: [new S({
			key: U,
			view(t) {
				return {
					update: async (t, n) => {
						this.key?.getState(t.state).updatedBlocks.size > 0 && (e = setTimeout(() => {
							t.dispatch(t.state.tr.setMeta(U, { clearUpdate: !0 }));
						}, 0));
					},
					destroy: () => {
						e && clearTimeout(e);
					}
				};
			},
			state: {
				init() {
					return {
						prevTransactionOldBlockAttrs: {},
						currentTransactionOldBlockAttrs: {},
						updatedBlocks: /* @__PURE__ */ new Set()
					};
				},
				apply(e, t, n, r) {
					if (t.currentTransactionOldBlockAttrs = {}, t.updatedBlocks.clear(), !e.docChanged) return t;
					let i = e.changedRange();
					if (!i) return t;
					let a = e.mapping.invert(), o = {
						from: a.map(i.from, -1),
						to: a.map(i.to, 1)
					}, s = {}, c = x(n.doc, o, (e) => e.attrs.id), l = new Map(c.map((e) => [e.node.attrs.id, e])), u = x(r.doc, i, (e) => e.attrs.id);
					for (let e of u) {
						let i = l.get(e.node.attrs.id), a = i?.node.firstChild, o = e.node.firstChild;
						if (i && a && o) {
							let c = {
								index: o.attrs.index,
								level: o.attrs.level,
								type: o.type.name,
								depth: r.doc.resolve(e.pos).depth
							}, l = {
								index: a.attrs.index,
								level: a.attrs.level,
								type: a.type.name,
								depth: n.doc.resolve(i.pos).depth
							};
							s[e.node.attrs.id] = l, t.currentTransactionOldBlockAttrs[e.node.attrs.id] = l, (l.index !== c.index || l.level !== c.level || l.type !== c.type || l.depth !== c.depth) && (l["depth-change"] = l.depth - c.depth, t.updatedBlocks.add(e.node.attrs.id));
						}
					}
					return t.prevTransactionOldBlockAttrs = s, t;
				}
			},
			props: { decorations(e) {
				let t = this.getState(e);
				if (t.updatedBlocks.size === 0) return;
				let n = [];
				return e.doc.descendants((e, r) => {
					if (!e.attrs.id || !t.updatedBlocks.has(e.attrs.id)) return;
					let i = t.currentTransactionOldBlockAttrs[e.attrs.id], a = {};
					for (let [e, t] of Object.entries(i)) a["data-prev-" + dt[e]] = t || "none";
					n.push(D.node(r, r + e.nodeSize, { ...a }));
				}), O.create(e.doc, n);
			} }
		})]
	};
});
//#endregion
//#region src/extensions/getDraggableBlockFromElement.ts
function pt(e, t) {
	for (; e && e.parentElement && e.parentElement !== t.dom && e.getAttribute?.("data-node-type") !== "blockContainer";) e = e.parentElement;
	if (e.getAttribute?.("data-node-type") === "blockContainer") return {
		node: e,
		id: e.getAttribute("data-id")
	};
}
//#endregion
//#region src/api/exporters/markdown/util/removeUnderlinesRehypePlugin.ts
function mt() {
	let e = (t) => {
		let n = t.children.length;
		for (let r = 0; r < n; r++) {
			let i = t.children[r];
			if (i.type === "element" && (e(i), i.tagName === "u")) if (i.children.length > 0) {
				t.children.splice(r, 1, ...i.children);
				let e = i.children.length - 1;
				n += e, r += e;
			} else t.children.splice(r, 1), n--, r--;
		}
	};
	return e;
}
//#endregion
//#region src/api/exporters/markdown/util/addSpacesToCheckboxesRehypePlugin.ts
function ht() {
	let e = (t) => {
		if (t.children && "length" in t.children && t.children.length) for (let n = t.children.length - 1; n >= 0; n--) {
			let r = t.children[n], i = n + 1 < t.children.length ? t.children[n + 1] : void 0;
			r.type === "element" && r.tagName === "input" && r.properties?.type === "checkbox" && i?.type === "element" && i.tagName === "p" ? (i.tagName = "span", i.children.splice(0, 0, Le(document.createTextNode(" ")))) : e(r);
		}
	};
	return e;
}
//#endregion
//#region src/api/exporters/markdown/util/convertVideoToMarkdownRehypePlugin.ts
function gt() {
	return (e) => {
		Re(e, "element", (e, t, n) => {
			if (n && e.tagName === "video") {
				let r = e.properties?.src || e.properties?.["data-url"] || "", i = e.properties?.title || e.properties?.["data-name"] || "";
				n.children[t] = {
					type: "text",
					value: `![${i}](${r})`
				};
			}
		});
	};
}
//#endregion
//#region src/api/exporters/markdown/markdownExporter.ts
function W(e) {
	return Ie().use(Me, { fragment: !0 }).use(gt).use(mt).use(ht).use(Ne).use(Pe).use(Fe, { handlers: { text: (e) => e.value } }).processSync(e).value;
}
function _t(e, t, n, r) {
	return W(P(t, n).exportBlocks(e, r));
}
//#endregion
//#region src/api/nodeConversions/fragmentToBlocks.ts
function vt(e) {
	let t = [];
	return e.descendants((e) => {
		let n = g(e);
		return e.type.name === "blockContainer" && e.firstChild?.type.name === "blockGroup" ? !0 : e.type.name === "columnList" && e.childCount === 1 ? (e.firstChild?.forEach((e) => {
			t.push(h(e, n));
		}), !1) : e.type.isInGroup("bnBlock") ? (t.push(h(e, n)), !1) : !0;
	}), t;
}
//#endregion
//#region src/extensions/SideMenu/MultipleNodeSelection.ts
var G = class e extends w {
	nodes;
	constructor(e, t) {
		super(e, t);
		let n = e.node();
		this.nodes = [], e.doc.nodesBetween(e.pos, t.pos, (e, t, r) => {
			if (r !== null && r.eq(n)) return this.nodes.push(e), !1;
		});
	}
	static create(t, n, r = n) {
		return new e(t.resolve(n), t.resolve(r));
	}
	content() {
		return new re(b.from(this.nodes), 0, 0);
	}
	eq(t) {
		if (!(t instanceof e) || this.nodes.length !== t.nodes.length || this.from !== t.from || this.to !== t.to) return !1;
		for (let e = 0; e < this.nodes.length; e++) if (!this.nodes[e].eq(t.nodes[e])) return !1;
		return !0;
	}
	map(t, n) {
		let r = n.mapResult(this.from), i = n.mapResult(this.to);
		return i.deleted ? w.near(t.resolve(r.pos)) : r.deleted ? w.near(t.resolve(i.pos)) : new e(t.resolve(r.pos), t.resolve(i.pos));
	}
	toJSON() {
		return {
			type: "multiple-node",
			anchor: this.anchor,
			head: this.head
		};
	}
};
w.jsonID("multiple-node", G);
//#endregion
//#region src/extensions/SideMenu/dragging.ts
var K;
function yt(e, t) {
	let n, r, i = t.resolve(e.from).node().type.spec.group === "blockContent", a = t.resolve(e.to).node().type.spec.group === "blockContent", o = Math.min(e.$anchor.depth, e.$head.depth);
	if (i && a) {
		let i = e.$from.start(o - 1), a = e.$to.end(o - 1);
		n = t.resolve(i - 1).pos, r = t.resolve(a + 1).pos;
	} else n = e.from, r = e.to;
	return {
		from: n,
		to: r
	};
}
function bt(e, t, n = t) {
	t === n && (n += e.state.doc.resolve(t + 1).node().nodeSize);
	let r = e.domAtPos(t).node.cloneNode(!0), i = e.domAtPos(t).node, a = (e, t) => Array.prototype.indexOf.call(e.children, t), o = a(i, e.domAtPos(t + 1).node.parentElement), s = a(i, e.domAtPos(n - 1).node.parentElement);
	for (let e = i.childElementCount - 1; e >= 0; e--) (e > s || e < o) && r.removeChild(r.children[e]);
	xt(e.root), K = r;
	let c = K.getElementsByTagName("iframe");
	for (let e = 0; e < c.length; e++) {
		let t = c[e], n = t.parentElement;
		n && n.removeChild(t);
	}
	let l = e.dom.className.split(" ").filter((e) => e !== "ProseMirror" && e !== "bn-root" && e !== "bn-editor").join(" ");
	K.className = K.className + " bn-drag-preview " + l, e.root instanceof ShadowRoot ? e.root.appendChild(K) : e.root.body.appendChild(K);
}
function xt(e) {
	K !== void 0 && (e instanceof ShadowRoot ? e.removeChild(K) : e.body.removeChild(K), K = void 0);
}
function St(e, n, r) {
	if (!e.dataTransfer || r.headless) return;
	let i = r.prosemirrorView, a = t(n.id, i.state.doc);
	if (!a) throw Error(`Block with ID ${n.id} not found`);
	let o = a.posBeforeNode;
	if (o != null) {
		let t = i.state.selection, n = i.state.doc, { from: a, to: s } = yt(t, n), c = a <= o && o < s, l = t.$anchor.node() !== t.$head.node() || t instanceof G;
		c && l ? (i.dispatch(i.state.tr.setSelection(G.create(n, a, s))), bt(i, a, s)) : (i.dispatch(i.state.tr.setSelection(se.create(i.state.doc, o))), bt(i, o));
		let u = i.state.selection.content(), d = r.pmSchema, f = i.serializeForClipboard(u).dom.innerHTML, p = P(d, r), m = vt(u.content), h = p.exportBlocks(m, {}), g = W(h);
		e.dataTransfer.clearData(), e.dataTransfer.setData("blocknote/html", f), e.dataTransfer.setData("text/html", h), e.dataTransfer.setData("text/plain", g), e.dataTransfer.effectAllowed = "move", e.dataTransfer.setDragImage(K, 0, 0);
	}
}
//#endregion
//#region src/extensions/SideMenu/SideMenu.ts
var Ct = 250;
function q(e, t, n = !0) {
	let r = e.root.elementsFromPoint(t.left, t.top);
	for (let i of r) if (e.dom.contains(i)) return n && i.closest("[data-node-type=columnList]") ? q(e, {
		left: t.left + 50,
		top: t.top
	}, !1) : pt(i, e);
}
function wt(e, t) {
	if (!t.dom.firstChild) return;
	let n = t.dom.firstChild.getBoundingClientRect(), r = q(t, {
		left: Math.min(Math.max(n.left + 10, e.x), n.right - 10),
		top: e.y
	});
	if (r) return q(t, {
		left: r.node.getBoundingClientRect().right - 10,
		top: e.y
	}, !1);
}
var Tt = class {
	state;
	emitUpdate;
	mousePos;
	hoveredBlock;
	menuFrozen = !1;
	isDragOrigin = !1;
	constructor(e, t, n) {
		this.editor = e, this.pmView = t, this.emitUpdate = () => {
			if (!this.state) throw Error("Attempting to update uninitialized side menu");
			n(this.state);
		}, this.pmView.root.addEventListener("dragstart", this.onDragStart), this.pmView.root.addEventListener("dragover", this.onDragOver), this.pmView.root.addEventListener("drop", this.onDrop, !0), this.pmView.root.addEventListener("dragend", this.onDragEnd, !0), this.pmView.root.addEventListener("mousemove", this.onMouseMove, !0), this.pmView.root.addEventListener("keydown", this.onKeyDown, !0);
	}
	updateState = (e) => {
		this.state = e, this.emitUpdate(this.state);
	};
	updateStateFromMousePos = () => {
		if (this.menuFrozen || !this.mousePos) return;
		let e = this.findClosestEditorElement({
			clientX: this.mousePos.x,
			clientY: this.mousePos.y
		});
		if (e?.element !== this.pmView.dom || e.distance > Ct) {
			this.state?.show && (this.state.show = !1, this.updateState(this.state));
			return;
		}
		let t = wt(this.mousePos, this.pmView);
		if (!t || !this.editor.isEditable) {
			this.state?.show && (this.state.show = !1, this.updateState(this.state));
			return;
		}
		if (!(this.state?.show && this.hoveredBlock?.hasAttribute("data-id") && this.hoveredBlock?.getAttribute("data-id") === t.id) && (this.hoveredBlock = t.node, this.editor.isEditable)) {
			let e = t.node.getBoundingClientRect(), n = t.node.closest("[data-node-type=column]");
			this.state = {
				show: !0,
				referencePos: new DOMRect(n ? n.firstElementChild.getBoundingClientRect().x : this.pmView.dom.firstChild.getBoundingClientRect().x, e.y, e.width, e.height),
				block: this.editor.getBlock(this.hoveredBlock.getAttribute("data-id"))
			}, this.updateState(this.state);
		}
	};
	onDragStart = (e) => {
		let t = e.dataTransfer?.getData("blocknote/html");
		if (!t || this.pmView.dragging) return;
		let n = document.createElement("div");
		n.innerHTML = t;
		let r = ue.fromSchema(this.pmView.state.schema).parse(n, { topNode: this.pmView.state.schema.nodes.blockGroup.create() });
		this.pmView.dragging = {
			slice: new de(r.content, 0, 0),
			move: !0
		};
	};
	findClosestEditorElement = (e) => {
		let t = Array.from(this.pmView.root.querySelectorAll(".bn-editor"));
		if (t.length === 0) return null;
		let n = t[0], r = Number.MAX_VALUE;
		return t.forEach((t) => {
			let i = t.querySelector(".bn-block-group").getBoundingClientRect(), a = e.clientX < i.left ? i.left - e.clientX : e.clientX > i.right ? e.clientX - i.right : 0, o = e.clientY < i.top ? i.top - e.clientY : e.clientY > i.bottom ? e.clientY - i.bottom : 0, s = Math.sqrt(a ** 2 + o ** 2);
			s < r && (r = s, n = t);
		}), {
			element: n,
			distance: r
		};
	};
	onDragOver = (e) => {
		if (e.synthetic || !(this.pmView.dragging !== null || this.isDragOrigin || e.dataTransfer?.types.includes("blocknote/html") || e.target instanceof Node && this.pmView.dom.contains(e.target))) return;
		let t = this.getDragEventContext(e);
		if (!t || !t.isDropPoint) {
			this.closeDropCursor();
			return;
		}
		t.isDropPoint && !t.isDropWithinEditorBounds && this.dispatchSyntheticEvent(e);
	};
	closeDropCursor = () => {
		let e = new Event("dragleave", { bubbles: !1 });
		e.synthetic = !0, this.pmView.dom.dispatchEvent(e);
	};
	getDragEventContext = (e) => {
		if (!(this.pmView.dragging !== null || this.isDragOrigin || e.dataTransfer?.types.includes("blocknote/html") || e.target instanceof Node && this.pmView.dom.contains(e.target))) return;
		let t = !e.dataTransfer?.types.includes("blocknote/html") && !!this.pmView.dragging, n = !!this.isDragOrigin, r = t || n, i = this.findClosestEditorElement(e);
		if (!i || i.distance > Ct) return;
		let a = i.element === this.pmView.dom, o = a && i.distance === 0;
		if (!(!a && !r)) return {
			isDropPoint: a,
			isDropWithinEditorBounds: o,
			isDragOrigin: r
		};
	};
	onDrop = (e) => {
		if (e.synthetic || !(this.pmView.dragging !== null || this.isDragOrigin || e.dataTransfer?.types.includes("blocknote/html") || e.target instanceof Node && this.pmView.dom.contains(e.target))) return;
		let t = this.getDragEventContext(e);
		if (!t) {
			this.closeDropCursor();
			return;
		}
		let { isDropPoint: n, isDropWithinEditorBounds: r, isDragOrigin: i } = t;
		if (!r && n && this.dispatchSyntheticEvent(e), n) {
			if (this.pmView.dragging) return;
			this.pmView.dispatch(this.pmView.state.tr.setSelection(xe.create(this.pmView.state.tr.doc, this.pmView.state.tr.selection.anchor)));
			return;
		} else if (i) {
			setTimeout(() => this.pmView.dispatch(this.pmView.state.tr.deleteSelection()), 0);
			return;
		}
	};
	onDragEnd = (e) => {
		e.synthetic || (this.pmView.dragging = null);
	};
	onKeyDown = (e) => {
		this.state?.show && this.editor.isFocused() && (this.state.show = !1, this.emitUpdate(this.state));
	};
	onMouseMove = (e) => {
		if (this.menuFrozen) return;
		this.mousePos = {
			x: e.clientX,
			y: e.clientY
		};
		let t = this.pmView.dom.getBoundingClientRect();
		if (this.mousePos.x > t.left && this.mousePos.x < t.right && this.mousePos.y > t.top && this.mousePos.y < t.bottom && e && e.target && !this.editor.isWithinEditor(e.target)) {
			this.state?.show && (this.state.show = !1, this.emitUpdate(this.state));
			return;
		}
		this.updateStateFromMousePos();
	};
	dispatchSyntheticEvent(e) {
		let t = new Event(e.type, e), n = this.pmView.dom.firstChild.getBoundingClientRect();
		t.clientX = e.clientX, t.clientY = e.clientY, t.clientX = Math.min(Math.max(e.clientX, n.left), n.left + n.width), t.clientY = Math.min(Math.max(e.clientY, n.top), n.top + n.height), t.dataTransfer = e.dataTransfer, t.preventDefault = () => e.preventDefault(), t.synthetic = !0, this.pmView.dom.dispatchEvent(t);
	}
	update(e, t) {
		!t.doc.eq(this.pmView.state.doc) && this.state?.show && this.updateStateFromMousePos();
	}
	destroy() {
		this.state?.show && (this.state.show = !1, this.emitUpdate(this.state)), this.pmView.root.removeEventListener("mousemove", this.onMouseMove, !0), this.pmView.root.removeEventListener("dragstart", this.onDragStart), this.pmView.root.removeEventListener("dragover", this.onDragOver), this.pmView.root.removeEventListener("drop", this.onDrop, !0), this.pmView.root.removeEventListener("dragend", this.onDragEnd, !0), this.pmView.root.removeEventListener("keydown", this.onKeyDown, !0);
	}
}, Et = new E("SideMenuPlugin"), Dt = v(({ editor: e }) => {
	let t, n = _(void 0);
	return {
		key: "sideMenu",
		store: n,
		prosemirrorPlugins: [new T({
			key: Et,
			view: (r) => (t = new Tt(e, r, (e) => {
				n.setState({ ...e });
			}), t)
		})],
		blockDragStart(n, r) {
			t && (t.isDragOrigin = !0), St(n, r, e);
		},
		blockDragEnd() {
			xt(e.prosemirrorView.root), t && (t.isDragOrigin = !1), e.blur();
		},
		freezeMenu() {
			t.menuFrozen = !0, t.state.show = !0, t.emitUpdate(t.state);
		},
		unfreezeMenu() {
			t.menuFrozen = !1, t.state.show = !1, t.emitUpdate(t.state);
		},
		hideMenuIfNotFrozen() {
			!t.menuFrozen && t.state?.show && (t.state.show = !1, t.emitUpdate(t.state));
		}
	};
}), J;
async function Ot() {
	return J || (J = (async () => {
		let [e, t] = await Promise.all([import("emoji-mart"), import("@emoji-mart/data")]), n = "default" in e ? e.default : e, r = "default" in t ? t.default : t;
		return await n.init({ data: r }), {
			emojiMart: n,
			emojiData: r
		};
	})(), J);
}
async function kt(e, t) {
	if (!("text" in e.schema.inlineContentSchema) || e.schema.inlineContentSchema.text !== ee.text) return [];
	let { emojiData: n, emojiMart: r } = await Ot();
	return (t.trim() === "" ? Object.values(n.emojis) : await r.SearchIndex.search(t)).map((t) => ({
		id: t.skins[0].native,
		onItemClick: () => e.insertInlineContent(t.skins[0].native + " ")
	}));
}
//#endregion
//#region src/extensions/TableHandles/TableHandles.ts
var Y;
function X(e) {
	Y || (Y = document.createElement("div"), Y.innerHTML = "_", Y.style.opacity = "0", Y.style.height = "1px", Y.style.width = "1px", e instanceof Document ? e.body.appendChild(Y) : e.appendChild(Y));
}
function At(e) {
	Y &&= (e instanceof Document ? e.body.removeChild(Y) : e.removeChild(Y), void 0);
}
function Z(e) {
	return Array.prototype.indexOf.call(e.parentElement.childNodes, e);
}
function jt(e) {
	let t = e;
	for (; t && t.nodeName !== "TD" && t.nodeName !== "TH" && !t.classList.contains("tableWrapper");) {
		if (t.classList.contains("ProseMirror")) return;
		let e = t.parentNode;
		if (!e || !(e instanceof Element)) return;
		t = e;
	}
	return t.nodeName === "TD" || t.nodeName === "TH" ? {
		type: "cell",
		domNode: t,
		tbodyNode: t.closest("tbody")
	} : {
		type: "wrapper",
		domNode: t,
		tbodyNode: t.querySelector("tbody")
	};
}
function Mt(e, t) {
	let n = t.querySelectorAll(e);
	for (let e = 0; e < n.length; e++) n[e].style.visibility = "hidden";
}
var Nt = class {
	state;
	emitUpdate;
	tableId;
	tablePos;
	tableElement;
	menuFrozen = !1;
	mouseState = "up";
	prevWasEditable = null;
	constructor(e, t, n) {
		this.editor = e, this.pmView = t, this.emitUpdate = () => {
			if (!this.state) throw Error("Attempting to update uninitialized image toolbar");
			n(this.state);
		}, t.dom.addEventListener("mousemove", this.mouseMoveHandler), t.dom.addEventListener("mousedown", this.viewMousedownHandler), window.addEventListener("mouseup", this.mouseUpHandler), t.root.addEventListener("dragover", this.dragOverHandler), t.root.addEventListener("drop", this.dropHandler);
	}
	viewMousedownHandler = () => {
		this.mouseState = "down";
	};
	mouseUpHandler = (e) => {
		this.mouseState = "up", this.mouseMoveHandler(e);
	};
	mouseMoveHandler = (e) => {
		if (this.menuFrozen || this.mouseState === "selecting" || !(e.target instanceof Element) || !this.pmView.dom.contains(e.target)) return;
		let n = jt(e.target);
		if (n?.type === "cell" && this.mouseState === "down" && !this.state?.draggingState) {
			this.mouseState = "selecting", this.state?.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
			return;
		}
		if (!n || !this.editor.isEditable) {
			this.state?.show && (this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate());
			return;
		}
		if (!n.tbodyNode) return;
		let r = n.tbodyNode.getBoundingClientRect(), i = pt(n.domNode, this.pmView);
		if (!i) return;
		this.tableElement = i.node;
		let a, o = this.editor.transact((e) => t(i.id, e.doc));
		if (!o) throw Error(`Block with ID ${i.id} not found`);
		let s = h(o.node, this.editor.pmSchema, this.editor.schema.blockSchema, this.editor.schema.inlineContentSchema, this.editor.schema.styleSchema);
		if (p(this.editor, "table") && (this.tablePos = o.posBeforeNode + 1, a = s), !a) return;
		this.tableId = i.id;
		let c = n.domNode.closest(".tableWrapper")?.querySelector(".table-widgets-container");
		if (n?.type === "wrapper") {
			let t = e.clientY >= r.bottom - 1 && e.clientY < r.bottom + 20, n = e.clientX >= r.right - 1 && e.clientX < r.right + 20, i = this.state?.block.id !== a.id || e.clientX > r.right || e.clientY > r.bottom;
			this.state = {
				...this.state,
				show: !0,
				showAddOrRemoveRowsButton: t,
				showAddOrRemoveColumnsButton: n,
				referencePosTable: r,
				block: a,
				widgetContainer: c,
				colIndex: i ? void 0 : this.state?.colIndex,
				rowIndex: i ? void 0 : this.state?.rowIndex,
				referencePosCell: i ? void 0 : this.state?.referencePosCell
			};
		} else {
			let e = Z(n.domNode), t = Z(n.domNode.parentElement), o = n.domNode.getBoundingClientRect();
			if (this.state !== void 0 && this.state.show && this.tableId === i.id && this.state.rowIndex === t && this.state.colIndex === e) return;
			this.state = {
				show: !0,
				showAddOrRemoveColumnsButton: e === a.content.rows[0].cells.length - 1,
				showAddOrRemoveRowsButton: t === a.content.rows.length - 1,
				referencePosTable: r,
				block: a,
				draggingState: void 0,
				referencePosCell: o,
				colIndex: e,
				rowIndex: t,
				widgetContainer: c
			};
		}
		return this.emitUpdate(), !1;
	};
	dragOverHandler = (e) => {
		if (this.state?.draggingState === void 0) return;
		e.preventDefault(), e.dataTransfer.dropEffect = "move", Mt(".prosemirror-dropcursor-block, .prosemirror-dropcursor-inline", this.pmView.root);
		let t = {
			left: Math.min(Math.max(e.clientX, this.state.referencePosTable.left + 1), this.state.referencePosTable.right - 1),
			top: Math.min(Math.max(e.clientY, this.state.referencePosTable.top + 1), this.state.referencePosTable.bottom - 1)
		}, n = this.pmView.root.elementsFromPoint(t.left, t.top).filter((e) => e.tagName === "TD" || e.tagName === "TH");
		if (n.length === 0) return;
		let r = n[0], i = !1, a = Z(r.parentElement), o = Z(r), s = this.state.draggingState.draggedCellOrientation === "row" ? this.state.rowIndex : this.state.colIndex, c = (this.state.draggingState.draggedCellOrientation === "row" ? a : o) !== s;
		(this.state.rowIndex !== a || this.state.colIndex !== o) && (this.state.rowIndex = a, this.state.colIndex = o, this.state.referencePosCell = r.getBoundingClientRect(), i = !0);
		let l = this.state.draggingState.draggedCellOrientation === "row" ? t.top : t.left;
		this.state.draggingState.mousePos !== l && (this.state.draggingState.mousePos = l, i = !0), i && this.emitUpdate(), c && this.editor.transact((e) => e.setMeta(Q, !0));
	};
	dropHandler = (e) => {
		if (this.mouseState = "up", this.state === void 0 || this.state.draggingState === void 0) return !1;
		if (this.state.rowIndex === void 0 || this.state.colIndex === void 0) throw Error("Attempted to drop table row or column, but no table block was hovered prior.");
		e.preventDefault();
		let { draggingState: t, colIndex: a, rowIndex: o } = this.state, s = this.state.block.content.columnWidths;
		if (t.draggedCellOrientation === "row") {
			if (!i(this.state.block, t.originalIndex, o)) return !1;
			let e = r(this.state.block, t.originalIndex, o);
			this.editor.updateBlock(this.state.block, {
				type: "table",
				content: {
					...this.state.block.content,
					rows: e
				}
			});
		} else {
			if (!n(this.state.block, t.originalIndex, a)) return !1;
			let e = u(this.state.block, t.originalIndex, a), [r] = s.splice(t.originalIndex, 1);
			s.splice(a, 0, r), this.editor.updateBlock(this.state.block, {
				type: "table",
				content: {
					...this.state.block.content,
					columnWidths: s,
					rows: e
				}
			});
		}
		return this.editor.setTextCursorPosition(this.state.block.id), !0;
	};
	update() {
		if (!this.state || !this.state.show) return;
		if (this.state.block = this.editor.getBlock(this.state.block.id), !this.state.block || this.state.block.type !== "table" || !this.tableElement?.isConnected) {
			this.state.show = !1, this.state.showAddOrRemoveRowsButton = !1, this.state.showAddOrRemoveColumnsButton = !1, this.emitUpdate();
			return;
		}
		let { height: t, width: n } = e(this.state.block);
		this.state.rowIndex !== void 0 && this.state.colIndex !== void 0 && (this.state.rowIndex >= t && (this.state.rowIndex = t - 1), this.state.colIndex >= n && (this.state.colIndex = n - 1));
		let r = this.tableElement.querySelector("tbody");
		if (!r) throw Error("Table block does not contain a 'tbody' HTML element. This should never happen.");
		if (this.state.rowIndex !== void 0 && this.state.colIndex !== void 0) {
			let e = r.children[this.state.rowIndex].children[this.state.colIndex];
			e ? this.state.referencePosCell = e.getBoundingClientRect() : (this.state.rowIndex = void 0, this.state.colIndex = void 0);
		}
		this.state.referencePosTable = r.getBoundingClientRect(), this.emitUpdate();
	}
	destroy() {
		this.pmView.dom.removeEventListener("mousemove", this.mouseMoveHandler), window.removeEventListener("mouseup", this.mouseUpHandler), this.pmView.dom.removeEventListener("mousedown", this.viewMousedownHandler), this.pmView.root.removeEventListener("dragover", this.dragOverHandler), this.pmView.root.removeEventListener("drop", this.dropHandler);
	}
}, Q = new C("TableHandlesPlugin"), Pt = v(({ editor: e }) => {
	let t, r = _(void 0);
	return {
		key: "tableHandles",
		store: r,
		prosemirrorPlugins: [new S({
			key: Q,
			view: (n) => (t = new Nt(e, n, (e) => {
				r.setState(e.block ? {
					...e,
					draggingState: e.draggingState ? { ...e.draggingState } : void 0
				} : void 0);
			}), t),
			props: { decorations: (e) => {
				if (t === void 0 || t.state === void 0 || t.state.draggingState === void 0 || t.tablePos === void 0) return;
				let r = t.state.draggingState.draggedCellOrientation === "row" ? t.state.rowIndex : t.state.colIndex;
				if (r === void 0) return;
				let a = [], { block: o, draggingState: s } = t.state, { originalIndex: c, draggedCellOrientation: u } = s;
				if (r === c || !o || u === "row" && !i(o, c, r) || u === "col" && !n(o, c, r)) return O.create(e.doc, a);
				let d = e.doc.resolve(t.tablePos + 1);
				return t.state.draggingState.draggedCellOrientation === "row" ? ne(t.state.block, r).forEach(({ row: t, col: n }) => {
					let i = e.doc.resolve(d.posAtIndex(t) + 1), o = e.doc.resolve(i.posAtIndex(n) + 1), s = o.node(), l = o.pos + (r > c ? s.nodeSize - 2 : 0);
					a.push(D.widget(l, () => {
						let e = document.createElement("div");
						return e.className = "bn-table-drop-cursor", e.style.left = "0", e.style.right = "0", r > c ? e.style.bottom = "-2px" : e.style.top = "-3px", e.style.height = "4px", e;
					}));
				}) : l(t.state.block, r).forEach(({ row: t, col: n }) => {
					let i = e.doc.resolve(d.posAtIndex(t) + 1), o = e.doc.resolve(i.posAtIndex(n) + 1), s = o.node(), l = o.pos + (r > c ? s.nodeSize - 2 : 0);
					a.push(D.widget(l, () => {
						let e = document.createElement("div");
						return e.className = "bn-table-drop-cursor", e.style.top = "0", e.style.bottom = "0", r > c ? e.style.right = "-2px" : e.style.left = "-3px", e.style.width = "4px", e;
					}));
				}), O.create(e.doc, a);
			} }
		})],
		colDragStart(n) {
			if (t === void 0 || t.state === void 0 || t.state.colIndex === void 0) throw Error("Attempted to drag table column, but no table block was hovered prior.");
			t.state.draggingState = {
				draggedCellOrientation: "col",
				originalIndex: t.state.colIndex,
				mousePos: n.clientX
			}, t.emitUpdate(), e.transact((e) => e.setMeta(Q, {
				draggedCellOrientation: t.state.draggingState.draggedCellOrientation,
				originalIndex: t.state.colIndex,
				newIndex: t.state.colIndex,
				tablePos: t.tablePos
			})), !e.headless && (X(e.prosemirrorView.root), n.dataTransfer.setDragImage(Y, 0, 0), n.dataTransfer.effectAllowed = "move");
		},
		rowDragStart(n) {
			if (t.state === void 0 || t.state.rowIndex === void 0) throw Error("Attempted to drag table row, but no table block was hovered prior.");
			t.state.draggingState = {
				draggedCellOrientation: "row",
				originalIndex: t.state.rowIndex,
				mousePos: n.clientY
			}, t.emitUpdate(), e.transact((e) => e.setMeta(Q, {
				draggedCellOrientation: t.state.draggingState.draggedCellOrientation,
				originalIndex: t.state.rowIndex,
				newIndex: t.state.rowIndex,
				tablePos: t.tablePos
			})), !e.headless && (X(e.prosemirrorView.root), n.dataTransfer.setDragImage(Y, 0, 0), n.dataTransfer.effectAllowed = "copyMove");
		},
		dragEnd() {
			if (t.state === void 0) throw Error("Attempted to drag table row, but no table block was hovered prior.");
			t.state.draggingState = void 0, t.emitUpdate(), e.transact((e) => e.setMeta(Q, null)), !e.headless && At(e.prosemirrorView.root);
		},
		freezeHandles() {
			t.menuFrozen = !0;
		},
		unfreezeHandles() {
			t.menuFrozen = !1;
		},
		hideHandlesIfNotFrozen() {
			!t.menuFrozen && t.state?.show && (t.state.show = !1, t.state.showAddOrRemoveRowsButton = !1, t.state.showAddOrRemoveColumnsButton = !1, t.emitUpdate());
		},
		getCellsAtRowHandle(e, t) {
			return ne(e, t);
		},
		getCellsAtColumnHandle(e, t) {
			return l(e, t);
		},
		setCellSelection(e, n, r = n) {
			if (!t) throw Error("Table handles view not initialized");
			let i = e.doc.resolve(t.tablePos + 1), a = e.doc.resolve(i.posAtIndex(n.row) + 1), o = e.doc.resolve(a.posAtIndex(n.col)), s = e.doc.resolve(i.posAtIndex(r.row) + 1), c = e.doc.resolve(s.posAtIndex(r.col)), l = e.tr;
			return l.setSelection(new fe(o, c)), e.apply(l);
		},
		addRowOrColumn(t, n) {
			e.exec((e, r) => {
				let i = this.setCellSelection(e, n.orientation === "row" ? {
					row: t,
					col: 0
				} : {
					row: 0,
					col: t
				});
				return n.orientation === "row" ? n.side === "above" ? ge(i, r) : he(i, r) : n.side === "left" ? me(i, r) : pe(i, r);
			});
		},
		removeRowOrColumn(t, n) {
			return n === "row" ? e.exec((e, n) => ve(this.setCellSelection(e, {
				row: t,
				col: 0
			}), n)) : e.exec((e, n) => _e(this.setCellSelection(e, {
				row: 0,
				col: t
			}), n));
		},
		mergeCells(t) {
			return e.exec((e, n) => ye(t ? this.setCellSelection(e, t.relativeStartCell, t.relativeEndCell) : e, n));
		},
		splitCell(t) {
			return e.exec((e, n) => be(t ? this.setCellSelection(e, t) : e, n));
		},
		getCellSelection() {
			return e.transact((e) => {
				let t = e.selection, n = t.$from, r = t.$to;
				if (d(t)) {
					let { ranges: e } = t;
					e.forEach((e) => {
						n = e.$from.min(n ?? e.$from), r = e.$to.max(r ?? e.$to);
					});
				} else if (n = e.doc.resolve(t.$from.pos - t.$from.parentOffset - 1), r = e.doc.resolve(t.$to.pos - t.$to.parentOffset - 1), n.pos === 0 || r.pos === 0) return;
				let i = e.doc.resolve(n.pos - n.parentOffset - 1), a = e.doc.resolve(r.pos - r.parentOffset - 1), o = e.doc.resolve(i.pos - i.parentOffset - 1), s = n.index(i.depth), c = i.index(o.depth), l = r.index(a.depth), u = a.index(o.depth), f = [];
				for (let e = c; e <= u; e++) for (let t = s; t <= l; t++) f.push({
					row: e,
					col: t
				});
				return {
					from: {
						row: c,
						col: s
					},
					to: {
						row: u,
						col: l
					},
					cells: f
				};
			});
		},
		getMergeDirection(t) {
			return e.transact((e) => {
				let n = d(e.selection) ? e.selection : void 0;
				if (!n || !t || n.ranges.length <= 1) return;
				let r = this.getCellSelection();
				if (r) return c(r.from, r.to, t) ? "vertical" : "horizontal";
			});
		},
		cropEmptyRowsOrColumns(e, t) {
			return a(e, t);
		},
		addRowsOrColumns(e, t, n) {
			return o(e, t, n);
		}
	};
}), $ = new C("trailingNode"), Ft = v(() => ({
	key: "trailingNode",
	prosemirrorPlugins: [new S({
		key: $,
		appendTransaction: (e, t, n) => {
			let { doc: r, tr: i, schema: a } = n, o = $.getState(n), s = r.content.size - 2, c = a.nodes.blockContainer, l = a.nodes.paragraph;
			if (o) return i.insert(s, c.create(void 0, l.create()));
		},
		state: {
			init: (e, t) => {},
			apply: (e, t) => {
				if (!e.docChanged) return t;
				let n = e.doc.lastChild;
				if (!n || n.type.name !== "blockGroup") throw Error("Expected blockGroup");
				if (n = n.lastChild, !n || n.type.name !== "blockContainer") return !0;
				let r = n.firstChild;
				if (!r) throw Error("Expected blockContent");
				return n.nodeSize > 4 || r.type.spec.content !== "inline*";
			}
		}
	})]
}));
//#endregion
export { qe as C, We as D, R as E, I as O, Ye as S, z as T, it as _, kt as a, et as b, Et as c, W as d, ft as f, at as g, ot as h, Q as i, P as k, vt as l, ct as m, Pt as n, Dt as o, ut as p, Nt as r, Tt as s, Ft as t, _t as u, rt as v, B as w, tt as x, nt as y };

//# sourceMappingURL=extensions-B0znnrCE.js.map